'use client';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import Image from 'next/image';

interface WorkItem {
  id: number;
  title: string;
  description: string;
  category: string;
  imageUrl: string;
  alt: string;
}

const works: WorkItem[] = [
  {
    id: 1,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Жилое строительство',
    imageUrl: "/assets/images/work-1.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
  {
    id: 2,
    title: 'Здесь будет название проекта',
    description: 'Тут будет категория',
    category: 'Коттеджное строительство',
    imageUrl: "/assets/images/work-2.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
  {
    id: 3,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Тут будет категория',
    imageUrl: "/assets/images/work-3.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
  {
    id: 4,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Хозяйственные постройки',
    imageUrl: "/assets/images/work-4.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
  {
    id: 5,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Коммерческое строительство',
    imageUrl: "/assets/images/work-5.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
  {
    id: 6,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Тут будет категория',
    imageUrl: "/assets/images/work-6.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
  {
    id: 7,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Тут будет категория',
    imageUrl: "/assets/images/work-7.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
  {
    id: 8,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Тут будет категория',
    imageUrl: "/assets/images/work-8.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
   {
    id: 9,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Тут будет категория',
    imageUrl: "/assets/images/work-9.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
   {
    id: 10,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Тут будет категория',
    imageUrl: "/assets/images/work-10.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
   {
    id: 111,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Тут будет категория',
    imageUrl: "/assets/images/work-11.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
   {
    id: 12,
    title: 'Здесь будет название проекта',
    description: 'Здесь будет описание проекта',
    category: 'Тут будет категория',
    imageUrl: "/assets/images/work-12.jpg",
    alt: "Здесь будет описание изображения для этого проекта"
  },
];
export default function OurWorksSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState<'next' | 'prev'>('next');
  const [isVisible, setIsVisible] = useState(false);
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  
  const sectionRef = useRef<HTMLElement>(null);
  const carouselRef = useRef<HTMLDivElement>(null);
  const autoPlayRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // Динамическое определение количества видимых карточек
  const getVisibleCount = () => {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width < 640) return 1; // xs: 1 карточка
      if (width < 768) return 1; // sm: 1 карточка  
      if (width < 1024) return 2; // md: 2 карточки
      if (width < 1200) return 2; // lg: 2 карточки для 1080x1920
      return 3; // xl+: 3 карточки
    }
    return 3; // fallback
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleCount());

  const getVisibleIndices = () => {
    const indices = [];
    for (let i = 0; i < visibleCount; i++) {
      indices.push((activeIndex + i) % works.length);
    }
    return indices;
  };

  // Обновление visibleCount при изменении размера окна
  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // initial call
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const stopAutoPlay = useCallback(() => {
    if (autoPlayRef.current) {
      clearInterval(autoPlayRef.current);
      autoPlayRef.current = null;
    }
  }, []);

  const startAutoPlay = useCallback(() => {
    stopAutoPlay();
    autoPlayRef.current = setInterval(() => {
      setDirection('next');
      setIsAnimating(true);
      setTimeout(() => {
        setActiveIndex((prev) => (prev + 1) % works.length);
        setIsAnimating(false);
      }, 400);
    }, 4000);
  }, [stopAutoPlay]);

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, [startAutoPlay, stopAutoPlay]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const goTo = (dir: 'next' | 'prev') => {
    if (isAnimating) return;
    stopAutoPlay();
    setDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setActiveIndex((prev) =>
        dir === 'next' ? (prev + 1) % works.length : (prev - 1 + works.length) % works.length
      );
      setIsAnimating(false);
      startAutoPlay();
    }, 400);
  };

  const goToIndex = (index: number) => {
    if (isAnimating || index === activeIndex) return;
    stopAutoPlay();
    setDirection(index > activeIndex ? 'next' : 'prev');
    setIsAnimating(true);
    setTimeout(() => {
      setActiveIndex(index);
      setIsAnimating(false);
      startAutoPlay();
    }, 400);
  };

  // Обработчики свайпов без изменений
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEndX(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStartX || !touchEndX) return;
    
    const diff = touchStartX - touchEndX;
    const minSwipeDistance = 50;

    if (Math.abs(diff) > minSwipeDistance) {
      if (diff > 0) {
        goTo('next');
      } else {
        goTo('prev');
      }
    }
    
    setTouchStartX(0);
    setTouchEndX(0);
  };

  const visibleIndices = getVisibleIndices();

  return (
    <section
      ref={sectionRef}
      id="our-works"
      className="relative py-24 overflow-hidden"
      style={{ background: 'var(--secondary)' }}>
      
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: `repeating-linear-gradient(
            45deg,
            var(--primary) 0px,
            var(--primary) 1px,
            transparent 1px,
            transparent 40px
          )`
        }} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="mb-10 sm:mb-16"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(2rem)',
            transition: 'all 0.9s cubic-bezier(0.16, 1, 0.3, 1)'
          }}>
          
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-12" style={{ background: 'var(--primary)' }} />
            <span className="text-sm font-medium uppercase tracking-widest" style={{ color: 'var(--primary)' }}>
              Портфолио
            </span>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 sm:gap-6">
            <h2
              className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight"
              style={{ color: 'var(--primary-foreground)' }}>
              Наши работы
            </h2>
            <p className="max-w-md text-sm sm:text-base leading-relaxed" style={{ color: 'rgba(245,240,235,0.6)' }}>
              Реализованные частные объекты по всей Беларуси
            </p>
          </div>
        </div>

        <div
          ref={carouselRef}
          className="touch-manipulation"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(3rem)',
            transition: 'all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.2s'
          }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}>
          
          <div 
            className={`grid gap-4 sm:gap-5 mb-8 sm:mb-10 ${
              visibleCount === 1 
                ? 'grid-cols-1' 
                : visibleCount === 2 
                ? 'md:grid-cols-2 lg:grid-cols-2' 
                : 'md:grid-cols-2 lg:grid-cols-3'
            }`}
          >
            {visibleIndices.map((workIndex, position) => {
              const work = works[workIndex];
              return (
                <div
                  key={`${workIndex}-${position}`}
                  className="group relative overflow-hidden rounded-2xl cursor-pointer w-full"
                  style={{
                    opacity: isAnimating ? 0.6 : 1,
                    transform: isAnimating ?
                    `translateX(${direction === 'next' ? '-12px' : '12px'})` :
                    'translateX(0)',
                    transition: 'opacity 0.4s ease, transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                    transitionDelay: `${position * 0.06}s`,
                    aspectRatio: '4/3', // Единый aspect ratio для всех
                  }}>
                  
                  <img
                    src={work.imageUrl}
                    alt={work.alt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    style={{ minHeight: visibleCount === 1 ? '320px' : '280px' }} />

                  <div
                    className="absolute inset-0"
                    style={{
                      background:
                      'linear-gradient(to top, rgba(26,26,26,0.92) 0%, rgba(26,26,26,0.4) 50%, transparent 100%)'
                    }} />
                </div>
              );
            })}
          </div>

          <div className="flex flex-col items-center gap-4 sm:hidden mb-8">
            <div className="flex items-center gap-2">
              {works.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goToIndex(i)}
                  aria-label={`Перейти к работе ${i + 1}`}
                  className="transition-all duration-300 rounded-full"
                  style={{
                    width: i === activeIndex ? '28px' : '8px',
                    height: '8px',
                    background: i === activeIndex ? 'var(--primary)' : 'rgba(245,240,235,0.25)'
                  }} />
              ))}
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={() => goTo('prev')}
                aria-label="Предыдущая работа"
                className="flex items-center justify-center w-12 h-12 rounded-full border transition-all duration-300 hover:scale-105 active:scale-95"
                style={{
                  borderColor: 'rgba(245,240,235,0.3)',
                  color: 'var(--primary-foreground)',
                  background: 'rgba(245,240,235,0.08)'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'var(--primary)';
                  (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--primary)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'rgba(245,240,235,0.08)';
                  (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(245,240,235,0.3)';
                }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>
              <button
                onClick={() => goTo('next')}
                aria-label="Следующая работа"
                className="flex items-center justify-center w-12 h-12 rounded-full border transition-all duration-300 hover:scale-105 active:scale-95"
                style={{
                  borderColor: 'rgba(245,240,235,0.3)',
                  color: 'var(--primary-foreground)',
                  background: 'rgba(245,240,235,0.08)'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'var(--primary)';
                  (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--primary)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'rgba(245,240,235,0.08)';
                  (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(245,240,235,0.3)';
                }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            </div>
          </div>

          <div className="hidden sm:flex items-center justify-between">
            <div className="flex items-center gap-2">
              {works.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goToIndex(i)}
                  aria-label={`Перейти к работе ${i + 1}`}
                  className="transition-all duration-300 rounded-full"
                  style={{
                    width: i === activeIndex ? '28px' : '8px',
                    height: '8px',
                    background: i === activeIndex ? 'var(--primary)' : 'rgba(245,240,235,0.25)'
                  }} />
              ))}
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={() => goTo('prev')}
                aria-label="Предыдущая работа"
                className="flex items-center justify-center w-11 h-11 rounded-full border transition-all duration-300 hover:scale-105"
                style={{
                  borderColor: 'rgba(245,240,235,0.2)',
                  color: 'var(--primary-foreground)',
                  background: 'rgba(245,240,235,0.05)'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'var(--primary)';
                  (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--primary)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'rgba(245,240,235,0.05)';
                  (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(245,240,235,0.2)';
                }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>
              <button
                onClick={() => goTo('next')}
                aria-label="Следующая работа"
                className="flex items-center justify-center w-11 h-11 rounded-full border transition-all duration-300 hover:scale-105"
                style={{
                  borderColor: 'rgba(245,240,235,0.2)',
                  color: 'var(--primary-foreground)',
                  background: 'rgba(245,240,235,0.05)'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'var(--primary)';
                  (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--primary)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLButtonElement).style.background = 'rgba(245,240,235,0.05)';
                  (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(245,240,235,0.2)';
                }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}